import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Flex } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import theme from 'styles/themes/default';

import { useTheme } from 'hooks/useTheme';

import Text from 'components/atom/Text/styles';

import { Container } from './styles';
import { getTheme } from './themes';
import { IInvitationStatsProps } from './types';

const InvitationStats: React.FC<IInvitationStatsProps> = ({ date, status, guest }) => {
  const { theme: globalTheme } = useTheme();
  const { icon, label, background } = getTheme(status, globalTheme);
  const { t } = useTranslation();

  return (
    <Container color={background}>
      <Box display="flex" justifyContent={label ? 'space-between' : 'center'} width="100%">
        <Flex align="center" gap={2}>
          <FontAwesomeIcon icon={icon} />

          <Text weight="900" size={20} color={theme.colors.dark.color}>
            {date}
          </Text>
        </Flex>

        {label && <div className="tag">{label}</div>}
      </Box>

      {status === 'sent' && (
        <div className="message">{`${guest}   ${t('meetings:list.pendingInvitation')}`}</div>
      )}
    </Container>
  );
};

export default InvitationStats;
